import axios from 'axios';

axios.defaults.baseURL = '';
const axiosInt = axios.create({
  headers: {
    withCredentials: true
  }
});

axiosInt.interceptors.response.use(
  (response) => response,
  (error) => {
    return Promise.reject(
      (error.response && error.response.data) || 'There is an error!'
    );
  }
);

export default axiosInt;
